import { GET_OFFICERS_ERROR } from './';

export default payload => ({ type: GET_OFFICERS_ERROR, payload });
